var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Color_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #231f20;\r\n      }\r\n\r\n      .st1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .st2 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -73.2,
    y1: 1155.2,
    x2: 1149.3,
    y2: -71.4,
    gradientTransform: "translate(0 1080) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#f47a20"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 63.4,
    y: 63.4,
    width: 953.3,
    height: 953.3,
    rx: 100.2,
    ry: 100.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Title"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.8,816l-2.6,5.2h-6.6c-4.6,0-7.9-4.5-7.9-10.3s3.4-9.9,7.9-9.9h9.2l-2.6,5.3h-6.6c-2.2,0-3.9,2-3.9,4.9s1.7,4.8,3.9,4.8h9.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M337,801l-7.9,13.5v6.6h-4.1v-6.7l-8-13.5h5.2l3.2,5.6c.5.8,1.5,2.6,1.8,3.2.2-.6.7-1.4,1.7-3.2l3-5.6h5.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M353.6,815.3c0,3.3-1.2,5.9-5.4,5.9h-11.6v-12.3h11.6c.6,0,1.1-.3,1.1-1.4s-.6-1.3-1.1-1.3h-11.6l2.7-5.3h8.7c3.2,0,5.2,1.9,5.2,5.6s-.9,3.7-1.8,4.2c1.1.5,2,2.1,2,4.5h.2ZM340.7,813.1v2.8h7.5c.9,0,1.3-.5,1.3-1.4s-.4-1.4-1.3-1.4h-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.8,816l-2.6,5.2h-12.7v-20.2h15.3l-2.6,5.3h-8.5v2.4h10.4l-2.3,4.6h-8.1v2.7h11.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M390.9,821.1h-5.4l-2.9-5.4h-6.3v5.4h-4.1v-10.3h11.5c1.2,0,2.2-.8,2.3-2v-.2c0-1.6-.8-2.3-2.3-2.3h-11.4l2.6-5.3h8.5c3,0,6.8,1.4,6.8,7.2s-1.3,5.7-3.5,6.4c.7.8,1.3,1.7,1.9,2.6l2.4,3.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M412.1,809.1c3.2,0,4.9,1.8,4.9,5.5s-1.7,6.6-5.7,6.6h-12.2l2.6-5.2h10c1,0,1.4-.5,1.4-1.5s-.5-1.4-1.4-1.4h-7.2c-3.4,0-4.9-2.3-4.9-5.8s1.7-6.3,5.7-6.3h11.4l-2.6,5.3h-9.1c-.9,0-1.4.4-1.4,1.4s.5,1.4,1.4,1.4h7.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M429.8,816h-6.9v5.1h-4.1v-10.3h11.3c1.3,0,2-.9,2-2.3s-.8-2.3-2-2.3h-11.3l2.7-5.3h8.3c4.1,0,6.4,3.1,6.4,7.6s-2.4,7.5-6.5,7.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440.8,821.1l2.5-5.2h5.7c-.4-.8-.9-2-1.4-2.9l-2.3-5.4-6.2,13.4h-4.8l8.5-18.3c.5-1.2,1.4-2.3,2.6-2.3s2,1,2.6,2.3l8.2,18.3h-15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M472.3,816l-2.6,5.2h-6.6c-4.5,0-7.9-4.5-7.9-10.3s3.4-9.9,7.9-9.9h9.2l-2.6,5.3h-6.6c-2.2,0-3.9,2-3.9,4.9s1.7,4.8,3.9,4.8h9.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M488.9,816l-2.6,5.2h-12.7v-20.2h15.3l-2.6,5.3h-8.5v2.4h10.4l-2.3,4.6h-8.1v2.7h11.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M506.8,821.1h-8.8v-12.6h4.1v7.4h4.8c2.3,0,3.9-2,3.9-4.8s-1.7-4.9-3.9-4.9h-8.8l2.6-5.3h6.2c4.6,0,7.9,4.1,7.9,9.9s-3.4,10.3-7.9,10.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M520.9,821.1h-4.1v-20.2h4.1v20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M531.5,808.6h8.5v12.6h-9.1c-4.5,0-7.9-4.5-7.9-10.3s3.4-9.9,7.9-9.9h9.4l-2.6,5.3h-6.8c-2.2,0-3.9,2-3.9,4.9s1.6,4.8,3.9,4.8h5v-2.9h-6.8l2.5-4.5h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M546.4,821.1h-4.1v-20.2h4.1v20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M565.3,801l-2.6,5.3h-4.7v15h-4.1v-15h-6.2l2.6-5.3h15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M567.9,821.1l2.4-5.2h5.7c-.4-.8-.9-2-1.4-2.9l-2.3-5.4-6.2,13.4h-4.8l8.5-18.3c.5-1.2,1.4-2.3,2.6-2.3s2,1,2.6,2.3l8.2,18.3h-15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M599,816l-2.6,5.2h-11.6v-20.2h4.1v15h10.2-.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "csd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M753.5,468.9v175c0,43.7-34.7,77.3-81.9,77.3s-80.3-32.4-80.3-77.3v-93.7h123.1v-81.2h-209.5v175c0,3.9.2,7.7.4,11.5l-145.2-.2c3.5-38.7,1.6-77.8-5.7-116.1-9.5-49.9-21.1-110.2-70.4-143.6-13.6-9.1-28.8-15.6-44.7-19l1,235.9c1.1,21.2,6.2,62.7,34.1,103.1,11,16,23.9,34.4,52.4,50.7,21.4,12.2,62.1,16.4,71.4,16.5,45.2.4,110.9,2.3,195.7.7,24.2,11.6,52.1,18,82.2,18,97,0,164.8-66,164.8-157.4v-123.5l-87.4-51.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M562.6,319.2c14-24,14.8-48,14.2-60.3l-176,3.5c-10.9,1.4-51.3,8.2-82.7,43.7-24.5,27.8-30.3,58.1-31.9,70.4l177.2-1.9c5.5,0,69-3.8,99.2-55.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460.7,626.3c-3.9,8.4-5.1,18-3.5,28.8v.6l6.3-.4c0-.3-.2-.8-.3-1.4-2.6-13.1,2.7-24.2,3.9-26.7,7.2-14.3,20.4-19.9,24.8-21.7,4.1-1.7,8.5-2.8,12.8-3.2v-5.9c-5.2.4-10.3,1.6-15.2,3.4-4,1.6-20.6,8.5-28.9,26.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.1,594.8c-.8-1.5-2.6-2.1-4.2-1.4s-1.3,1-1.5,1.7c-5.9,16.1-16.5,24.1-31.6,23.9,1.1-4.9,1.9-9.9,2.3-14.9,0-.7,0-1.4.2-2,.2-2.6.4-5.1.4-7.7v-6.5c0-1.1-.2-2.2-.2-3.2-.2-2.6-.5-5.2-1-7.8-.2-.6-.2-1.2-.4-1.8-.2-1.1-.4-2.2-.8-3.2-.2-.5-.3-1-.4-1.4-.2-.5-.4-1.1-.5-1.5-.2-1.1-.5-2-.9-3-.4-.9-.8-1.7-1.1-2.5-.8-2.1-1.8-4.2-2.9-6-.8-1.4-1.5-2.6-2.3-4-.6-.8-1.2-1.6-1.8-2.4s-.5-.8-.8-1.1c-7.6-8.8-14.8-15.1-21.5-18.9-7.7-4.6-15.8-8.7-24.1-12.1-4.7-2-9.7-3.9-15-5.9-5.2-1.8-10.6-3.7-16.1-5.7-10.8-3.5-20.9-8.9-29.9-15.9-4.1-3.3-7.4-7.6-9.7-12.3-2.2-4.8-3.2-10-3-15.3.2-5.4,1.1-10.6,2.7-15.8,1.8-4.8,4.2-9.4,7.2-13.6,6.2-8.1,12.8-13.9,20.1-17.4,7.1-3.5,12.9-5.4,17.5-6,1.2-.3,2.4-.4,3.7-.5.5,0,1,0,1.4-.2l1.8-.2c11.3,0,19.9,3.5,25.7,10.4,8,9.9,9.9,27.9,6.6,47.8h6c3.8-21.8,1.4-40.3-7.9-51.6-7.1-8.5-17.2-12.7-30.4-12.7h-3.5c-1.4,0-2.8,0-4.2.2-5.1.2-11.9,1.9-20.2,5.2-8.5,3.5-16.6,9.7-24.5,18.6-3.9,4.8-7.1,10-9.6,15.7-2.6,6.1-4.2,12.5-4.7,19.2-.7,7.2.3,14.4,2.9,21.1,2.7,6.8,6.9,12.8,12.3,17.8,10.9,9.3,22,16.2,33.7,20.5,2.1.9,4.2,1.7,6.2,2.5,3.3,1.4,6.6,2.6,9.7,3.9,5.1,2,9.7,4.2,14,6.1,7.4,3.3,14.6,7.1,21.5,11.3,5.8,3.3,11.6,8.1,17.3,14.3l.8.9c.5.5.8,1,1.2,1.4l1.7,2.7c.8,1.1,1.5,2.4,2,3.8.4.8.7,1.4,1.1,2.2,1.8,4.6,3,9.4,3.6,14.3.2,1.4.4,2.7.5,4.1s.2,2.7.2,4.2c0,2.2.2,4.4,0,6.6v2c-.2,5.1-.7,10-1.7,15-3.2-.5-6.5-1.2-9.8-1.9s-6.6-1.4-9.8-2.3v6.3c2.9.7,5.9,1.4,9,2,3.1.7,6.2,1.2,9.2,1.8-1.4,5.1-3.3,10-5.6,14.8-2.1,4.5-4.7,8.8-7.6,12.8-1.5,2.1-2.9,3.9-4.1,5.2.5,3.4,1.1,6.7,2.1,10,.4,1.2.8,2.3,1.1,3.4,3.8-3.5,7.3-7.2,10.6-11.3,8.1-10.1,14.2-21.6,18-34,18.7,1.1,31.7-8.4,39.2-28.2.2-.8.2-1.6-.2-2.3l-.2.2.2.6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsdLogo);
export default __webpack_public_path__ + "static/media/CSDLogo.1082da9b52eb6b876c90c5ab9c49199e.svg";
export { ForwardRef as ReactComponent };